import { render, staticRenderFns } from "./qrcode.vue?vue&type=template&id=55ed95fe&scoped=true"
import script from "./qrcode.vue?vue&type=script&lang=js"
export * from "./qrcode.vue?vue&type=script&lang=js"
import style0 from "./qrcode.vue?vue&type=style&index=0&id=55ed95fe&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55ed95fe",
  null
  
)

export default component.exports